import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-cpmBannerTypeShape",
  "use": "svg-icon-cpmBannerTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-cpmBannerTypeShape\"><g fill-rule=\"evenodd\"><path d=\"M8 3C2 3 0 8 0 8s2 5 8 5 8-5 8-5-2-5-8-5m0 2c3.281 0 5.008 1.905 5.728 2.999C13.003 9.099 11.276 11 8 11c-3.281 0-5.008-1.905-5.728-2.999C2.997 6.901 4.724 5 8 5\" /><path d=\"M8 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 8 6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol